import React from 'react';

const GitlabLogo = props => (
  <svg width={32} height={32} viewBox="0 0 500 500" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M495.199 280.225L467.64 195.41 413.023 27.313c-2.81-8.648-15.046-8.648-17.856 0L340.548 195.41H159.181l-54.62-168.097c-2.809-8.648-15.045-8.648-17.856 0L32.088 195.41 4.531 280.225a18.775 18.775 0 0 0 6.82 20.992l238.513 173.29 238.515-173.29a18.777 18.777 0 0 0 6.82-20.992"
        fill="#FC6D26"
      />
      <path d="M249.865 474.506l90.684-279.096H159.18l90.684 279.096z" fill="#E24329" />
      <path d="M249.865 474.506L159.18 195.41H32.089l217.776 279.095z" fill="#FC6D26" />
      <path
        d="M32.089 195.41l-27.56 84.815a18.773 18.773 0 0 0 6.822 20.991l238.514 173.29L32.089 195.41z"
        fill="#FCA326"
      />
      <path
        d="M32.089 195.411H159.18L104.56 27.314c-2.81-8.65-15.046-8.65-17.855 0L32.089 195.41z"
        fill="#E24329"
      />
      <path d="M249.865 474.506l90.684-279.095H467.64L249.865 474.506z" fill="#FC6D26" />
      <path
        d="M467.64 195.41l27.559 84.815a18.773 18.773 0 0 1-6.821 20.991l-238.514 173.29L467.64 195.41z"
        fill="#FCA326"
      />
      <path
        d="M467.64 195.411H340.548l54.619-168.097c2.81-8.65 15.047-8.65 17.856 0L467.64 195.41z"
        fill="#E24329"
      />
    </g>
  </svg>
);

export default GitlabLogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/GitlabLogo.es6.js